import React, { useEffect, useState } from 'react';
import T from 'prop-types';
// components
import Preloader from 'components/Preloader';
import LinkUnavailable from 'components/LinkUnavailable';
// endpoints
import { getFarmSVR } from 'endpoints/svr';

// Report pushes sent before EPN-3098 point at /svr-farms/:farmId/svrs/:svrId/review, which has no template id.
// Look the template up and open the current review page.
const LegacyReportReviewRedirect = ({ location, params: { farmId, svrId }, router }) => {
  const [isFailed, setIsFailed] = useState(false);

  useEffect(() => {
    getFarmSVR(farmId, svrId)
      .then((svr) => {
        if (!svr?.svr_template_id) {
          setIsFailed(true);
          return;
        }
        router.replace({
          ...location,
          pathname: `/report-farms/${farmId}/report-templates/${svr.svr_template_id}/reports/${svrId}/review`,
        });
      })
      .catch(() => setIsFailed(true));
  }, [farmId, svrId]);

  if (isFailed) return <LinkUnavailable />;

  return <Preloader isActive />;
};

LegacyReportReviewRedirect.propTypes = {
  location: T.object.isRequired,
  params: T.object.isRequired,
  router: T.object.isRequired,
};

export default LegacyReportReviewRedirect;
